if (!window.__PRODUCT_LIST_EXPANDED_INIT__) {
  window.__PRODUCT_LIST_EXPANDED_INIT__ = true;

  document.addEventListener('DOMContentLoaded', function() {
    function waitForDependencies(callback) {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && window.Shopify?.pubsub) {
        callback();
      } else {
        setTimeout(() => waitForDependencies(callback), 50);
      }
    }

    waitForDependencies(() => {
      const allButtons = document.querySelectorAll('.ja-product-card__add');
      if (allButtons.length === 0) return;

      function syncUI(cart) {
        allButtons.forEach(button => {
          const card = button.closest('[data-product-id]');
          if (!card) return;

          const variantId = card.dataset.productId;
          const inventory = parseInt(card.dataset.inventoryQuantity, 10);

          const itemInCart = cart.items.find(item => String(item.variant_id) === variantId);
          const quantityInCart = itemInCart ? itemInCart.quantity : 0;
          
          const isSoldOut = (inventory > 0 && quantityInCart >= inventory);
          
          button.classList.toggle('is-disabled', isSoldOut);
          if (isSoldOut) {
            button.setAttribute('disabled', 'disabled');
          } else {
            button.removeAttribute('disabled');
          }
        });
      }

      // --- SUBSCRIBER LOGIC ---
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => syncUI(cart))
        .catch(console.error);

      Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData) {
          syncUI(event.cartData);
        }
      });
      
      // --- PUBLISHER LOGIC ---
      document.addEventListener('click', function(e) {
        const addButton = e.target.closest('.ja-product-card__add');
        if (!addButton || addButton.classList.contains('is-disabled') || addButton.classList.contains('is-checked')) {
          if (addButton) e.preventDefault();
          return;
        }

        e.preventDefault();
        
        const card = addButton.closest('[data-product-id]');
        const variantId = card?.dataset.productId;
        if (!variantId) return;

        addButton.classList.add('is-checked');
        
        const body = { items: [{ id: variantId, quantity: 1 }] };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(response => {
            if (!response.ok) return response.json().then(error => { throw new Error(error.description || 'Bir hata oluştu.') });
            return response.json();
        })
        .then(addedItem => {
            return fetch('/cart.js').then(res => res.json());
        })
        .then(cart => {
            Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-card', cartData: cart });

            Shopify.pubsub.publish(PUB_SUB_EVENTS.toastShow, {
              message: 'Ürün sepete eklendi.',
              type: 'success'
            });
        })
        .catch(error => {
          console.error('Add to Cart Error (Product Card):', error);
          addButton.classList.remove('is-checked');
          
          Shopify.pubsub.publish(PUB_SUB_EVENTS.toastShow, {
              message: error.message || 'Sepete eklenemedi.',
              type: 'error'
          });
        })
        .finally(() => {
            clearTimeout(addButton.dataset.checkTimeout);
            addButton.dataset.checkTimeout = setTimeout(() => {
              addButton.classList.remove('is-checked');
            }, 2000);
        });
      });
    });
  });
}